// extracted by mini-css-extract-plugin
export default {"f":"_6e09866202","main":"_99cccec174","btn":"_21125193cc","w":"_177e3006d7","h":"eb84130e9d","lh25":"_5b0205a675","wb":"_2ec0541763","b":"d767a147e9","bx":"_06ece98c5f"};